module.exports = __webpack_public_path__ + "static/contact-02-crop-u410153-9e2e5aa5550e4b365644295074dd460e.png";